import React from "react";
import { Link } from "react-router-dom";
import { FLAGSHIP_GUIDES, TOTAL_GUIDE_COUNT } from "../../data/costGuidesDirectory";
import OptimizedImage from "../common/OptimizedImage";
import "../../styles/Home.css";

const PopularProjects = () => (
  <div className="section popular-projects">
    <h2 className="section-title">Popular Project Costs</h2>
    <div className="popular-projects-grid bento">
      {FLAGSHIP_GUIDES.map((p) => (
        <Link
          key={p.slug}
          to={`/cost-guides/${p.slug}`}
          className={`popular-project-card ${p.wide ? "bento-wide" : ""}`}
        >
          <div className="popular-project-photo">
            <OptimizedImage
              src={p.image}
              alt={p.title}
              width={240}
              height={240}
            />
          </div>
          <div className="popular-project-info">
            <span className="popular-project-title">{p.title}</span>
            <span className="popular-project-range">{p.range}</span>
          </div>
        </Link>
      ))}
    </div>

    {/* Compact link to the full directory — the full cluster list moved to
        its own /cost-guides page to declutter the homepage. */}
    <Link to="/cost-guides" className="home-hub-widget">
      <div className="home-hub-widget-icon">
        <i className="fas fa-book-open" aria-hidden="true" />
      </div>
      <div className="home-hub-widget-text">
        <span className="home-hub-widget-title">
          Browse all {TOTAL_GUIDE_COUNT} UK cost guides
        </span>
        <span className="home-hub-widget-sub">
          Kitchens, roofing, heating, extensions & more — indicative planning ranges
        </span>
      </div>
      <span className="home-hub-widget-arrow" aria-hidden="true">
        <i className="fas fa-arrow-right" />
      </span>
    </Link>
  </div>
);

export default PopularProjects;
